export const DOC_TYPE_OBJECT_FQN: any[] = [
  { ID: 'CONSUMER', Name: 'CONSUMER' },
  { ID: 'EMPLOYEE', Name: 'EMPLOYEE' },
  { ID: 'VEHICLE', Name: 'VEHICLE' },
  { ID: 'FACILITY', Name: 'FACILITY' },
  { ID: 'PERSON', Name: 'PERSON' },
];
